import React, { createContext, useCallback, useContext, useState, lazy, Suspense } from "react";
import { getUtmParams, openWhatsAppConsulta } from "./whatsappConfig";

const WhatsAppModal = lazy(() => import("../components/WhatsAppFlotante/WhatsAppModal"));

const WhatsAppConsultaContext = createContext(null);

export const WhatsAppConsultaProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleModalSubmit = async (values) => {
    setLoading(true);
    try {
      const { utm_source, utm_medium, utm_campaign } = getUtmParams();
      const { updateFirestoreEntry } = await import("./useFirestoreData");
      await updateFirestoreEntry("consultas", "validaciones", {
        ...values,
        utm_source,
        utm_medium,
        utm_campaign,
      });
      setOpen(false);
      openWhatsAppConsulta();
    } catch (error) {
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  const openConsultaForm = useCallback(() => {
    setOpen(true);
  }, []);

  return (
    <WhatsAppConsultaContext.Provider value={{ openConsultaForm, loading }}>
      {children}
      {open && (
        <Suspense fallback={null}>
          <WhatsAppModal
            open={open}
            onClose={() => setOpen(false)}
            onSubmit={handleModalSubmit}
            loading={loading}
          />
        </Suspense>
      )}
    </WhatsAppConsultaContext.Provider>
  );
};

export const useWhatsAppConsulta = () => {
  const context = useContext(WhatsAppConsultaContext);
  if (!context) {
    throw new Error("useWhatsAppConsulta debe usarse dentro de WhatsAppConsultaProvider");
  }
  return context;
};
